module.exports = __webpack_public_path__ + "static/Oswald-Bold-92837a203f0eb773631f579ddd426543.ttf";